import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/nft/title-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-b5e0d594"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nft-container" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "title-icon",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "content-wrapper" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createTextVNode("Loading"),
  /*#__PURE__*/_createElementVNode("span", { class: "dot" }, "...")
], -1))
const _hoisted_6 = { class: "right-wrapper" }
const _hoisted_7 = { class: "title-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-paw" }, null, -1))
const _hoisted_9 = { class: "properties-section" }
const _hoisted_10 = { class: "section-title" }
const _hoisted_11 = { class: "property-list" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "id", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = { class: "value" }
const _hoisted_20 = { class: "link-section" }

import { reactive } from 'vue';
import { useRoute } from 'vue-router';
import { getNftDetail } from '@/common/ipfs/nft';
import { getNftImgById, NFTDetail } from '@/configs/nft';
import { getUriByNFTId } from '@/common/contracts/apis/nft/nft-detail-api';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const { id: nftId } = route.params;
const data = reactive<{ uri: string, detail: NFTDetail }>({
  uri: '',
  detail: {
    id: '',
    nftType1: '',
    nftType2: '',
    animation_url: '',
    attributes: [],
    description: '',
    external_url: '',
    image: '',
    name: '',
  },
});

const nftImg = getNftImgById(nftId as string);

async function initData() {
  data.uri = await getUriByNFTId(nftId as string);
  if (!data.uri) return;

  console.log('nftId', nftId, 'uri:', data.uri);
  getNftDetail(data.uri).then((nft: NFTDetail) => {
    console.log(nft);
    data.detail = nft;
  });
}
initData();


return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(" " + _toDisplayString(_ctx.$t('pageTitle')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_image, {
        src: _unref(nftImg),
        class: "nft-img",
        fit: "contain"
      }, {
        placeholder: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["src"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createTextVNode(" " + _toDisplayString(_ctx.$t(_unref(data).detail.name)), 1)
        ]),
        _renderSlot(_ctx.$slots, "default"),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('properties')), 1),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('name')), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(data).detail.name), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(data).detail.id), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detail.attributes, (attr) => {
              return (_openBlock(), _createElementBlock("div", {
                key: attr.trait_type,
                class: "row"
              }, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(attr.trait_type), 1),
                _createElementVNode("div", _hoisted_19, _toDisplayString(attr.value), 1)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('tokenAddress')) + ": 0xEA5534Bac1291676595223579517D35Ad9C382eE", 1),
          _createElementVNode("div", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('metadataLink')) + ": ", 1),
            _createVNode(_component_el_link, {
              href: `https://ipfs.io/${_unref(data).uri}`,
              target: "_blank",
              underline: false,
              type: "primary"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" https://ipfs.io/" + _toDisplayString(_unref(data).uri), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ])
        ])
      ])
    ])
  ]))
}
}

})